export default "__VITE_ASSET__e4d1224f__"